/**
 * Pixelgipfel — theme toggle (light/dark)
 *
 * The initial theme is set by an inline script in layout/theme.liquid BEFORE
 * body renders, to avoid flash-of-wrong-theme. This asset only handles the
 * user-triggered toggle after page load.
 *
 * Any element with [data-pg-theme-toggle] becomes a toggle button.
 * The button's inner content can be swapped based on current theme via
 * [data-pg-icon-when="light"] / [data-pg-icon-when="dark"] children.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'pg-theme';
  const root = document.documentElement;

  // remember = a choice by the visitor; automatic follows of the system setting are not saved
  function applyTheme(next, remember) {
    root.setAttribute('data-theme', next);
    if (remember) {
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch (e) {
        /* ignore private-mode storage errors */
      }
      // m75: Wahl domainübergreifend teilen (Forum & Noesis lesen mit)
      document.cookie = 'pg_theme=' + next + '; domain=.pixelgipfel.ch; path=/; max-age=31536000; secure; samesite=lax';
    }
    updateIcons(next);
    // Dispatch event so other scripts can react
    document.dispatchEvent(new CustomEvent('pg:theme-change', { detail: { theme: next } }));
  }

  function setTheme(next) { applyTheme(next, true); }

  // One calm crossfade for the whole page instead of colours changing one after another (03.10.2026)
  function switchTheme(next) {
    var types = typeof document.startViewTransition === 'function' && typeof window.ViewTransition === 'function' &&
      'types' in window.ViewTransition.prototype;
    if (!types) { setTheme(next); return; }
    root.classList.add('pg-theme-swap');
    var transition = document.startViewTransition({ update: function () { setTheme(next); }, types: ['pg-theme'] });
    transition.finished.finally(function () { root.classList.remove('pg-theme-swap'); });
  }

  function updateIcons(theme) {
    document.querySelectorAll('[data-pg-icon-when]').forEach((el) => {
      const target = el.getAttribute('data-pg-icon-when');
      el.hidden = target !== theme;
    });
    // Keep switch-style toggles in sync for screen readers
    document.querySelectorAll('[data-pg-theme-toggle][role="switch"]').forEach((el) => {
      el.setAttribute('aria-checked', theme === 'dark' ? 'true' : 'false');
    });
  }

  function currentTheme() {
    return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function wire() {
    updateIcons(currentTheme());
    document.querySelectorAll('[data-pg-theme-toggle]').forEach((btn) => {
      if (btn.dataset.pgWired === '1') return;
      btn.dataset.pgWired = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        switchTheme(currentTheme() === 'dark' ? 'light' : 'dark');
      });
    });
  }

  // Wire on DOM ready and after Shopify section-load events (theme editor)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', wire);
  document.addEventListener('shopify:section:reorder', wire);

  // Follow system-preference changes only when the shop default is «auto» and the visitor has not chosen
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  if (mq && typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', function (e) {
      const stored = (function () {
        try {
          return localStorage.getItem(STORAGE_KEY);
        } catch (_) {
          return null;
        }
      })();
      if (!stored && (root.getAttribute('data-pg-default-theme') || 'auto') === 'auto') {
        applyTheme(e.matches ? 'dark' : 'light', false);
      }
    });
  }
})();
